import React from "react"
import Layout from "../components/layout"

export default function Datenschutz() {
  return (
    <Layout>
      <h1>Datenschutz</h1>
    </Layout>
  )
}
